// lang state
const state = {
  building_data_fields: [
    {key: "name", label: "lang.kwl.building_data.residential_unit"},
    {key: "storey", label: "lang.kwl.building_data.storey", class: "cellStorey"},
    {key: "level", label: "lang.kwl.building_data.level", class: "cellLevel"},
    {key: "space", label: "lang.kwl.building_geometry.space", class: "cellSpace text-nowrap"},
    {key: "height", label: "lang.kwl.building_geometry.height", class: "cellHeight text-nowrap"},
    {key: "volume", label: "lang.kwl.building_geometry.volume", class: "cellVolume text-nowrap"},
    {key: "multi_storey", label: "lang.kwl.building_data.multi_storey", class: "cellMultiStorey"},
    {key: "fireplace", label: "lang.kwl.building_data.fireplace", class: "cellFireplace"},
    {key: "windowless", label: "lang.kwl.building_data.windowless", class: "cellWindowless text-nowrap"},
    {key: "occupancy", label: "lang.kwl.building_data.occupancy", class: "cellOccupancy text-nowrap"},
    {key: "people_number", label: "lang.kwl.building_data.number_of_people", class: "cellPeopleNumber text-nowrap"},
  ],
  building_data_fields_at: [
    {key: "name", label: "lang.kwl.building_data.residential_unit"},
    {key: "storey", label: "lang.kwl.building_data.storey", class: "cellStorey"},
    {key: "level", label: "lang.kwl.building_data.level", class: "cellLevel"},
    {key: "space", label: "lang.kwl.building_geometry.space", class: "cellSpace text-nowrap"},
    {key: "height", label: "lang.kwl.building_geometry.height", class: "cellHeight text-nowrap"},
    {key: "volume", label: "lang.kwl.building_geometry.volume", class: "cellVolume text-nowrap"},
    {key: "multi_storey", label: "lang.kwl.building_data.multi_storey", class: "cellMultiStorey"},
    {key: "fireplace", label: "lang.kwl.building_data.fireplace", class: "cellFireplace"},
    {key: "people_number", label: "lang.kwl.building_data.number_of_people", class: "cellPeopleNumber text-nowrap"},
    {key: "co2voc", label: "lang.kwl.building_data.co2voc", class: "cellPeopleNumber text-nowrap"},
  ],
  building_type: [
    {value: 0, text: "lang.kwl.building_data.single_family_building"},
    {value: 1, text: "lang.kwl.building_data.apartment_building"},
    {value: 2, text: "lang.kwl.building_data.apartment"},
  ],
  building_location: [
    {value: 0, text: "lang.kwl.building_data.less_wind"},
    {value: 1, text: "lang.kwl.building_data.strong_wind"},
  ],
  building_airtightness: [
    {value: 0, text: "lang.kwl.building_data.category_a"},
    {value: 1, text: "lang.kwl.building_data.category_b"},
    {value: 2, text: "lang.kwl.building_data.blower_door"},
  ],
  building_heat_protection: [
    {value: 1, text: "lang.global.high"},
    {value: 0, text: "lang.global.low"},
  ],
  building_occupancy: [
    {value: 1, text: "lang.global.high"},
    {value: 0, text: "lang.global.low"},
  ],
  building_geometry_field: [
    {key: "name", label: "lang.kwl.building_geometry.residential_unit"},
    {key: "storey", label: "lang.kwl.building_geometry.storey"},
    {key: "space", label: "lang.kwl.building_geometry.space"},
    {key: "height", label: "lang.kwl.building_geometry.height"},
    {key: "volume", label: "lang.kwl.building_geometry.volume"},
  ],
  floors: [
    {value: 0, text: "lang.storey.basemant"},
    {value: 1, text: "lang.storey.first_floor"},
    {value: 2, text: "lang.storey.upper_floor"},
    {value: 3, text: "lang.storey.attic"},
    {value: 4, text: "lang.storey.apex"},
  ],
  building_geometry_result_field: [
    {key: "name", label: "lang.kwl.building_geometry_result.residential_unit"},
    {key: "storey", label: "lang.kwl.building_geometry_result.storey", class: "cellStorey"},
    {
      key: "infiltration",
      label: "lang.kwl.building_geometry_result.infiltration_multi",
      class: "cellInfiltrationMulti text-center text-nowrap"
    },
    {key: "compare", label: " "},
    {
      key: "moisure_protection",
      label: "lang.kwl.building_geometry_result.moisure_protection_multi",
      class: "cellMoisureProtectionMulti text-center text-nowrap"
    },
    {key: "ergo", label: " "},
    {key: "needLtm", label: "lang.kwl.building_geometry_result.need_ltm", class: "cellNeedLtm text-center text-nowrap"},
    {key: "space", label: " "},
  ],
  air_types: [
    {value: 1, text: "lang.air_type.exhaust_air"},
    {value: 2, text: "lang.air_type.supply_air"},
    {value: 3, text: "lang.air_type.overflow"},
  ],
  unit_air_vol_fields: [
    {key: "airtype", label: "lang.kwl.airvolume_calc.ventilation_method", class: ""},
    {key: "fl", label: "lang.kwl.airvolume_calc.ventilation_moisture_protection", class: "text-center cellVolumeflow"},
    {key: "rl", label: "lang.kwl.airvolume_calc.reduced_ventilation", class: "text-center cellVolumeflow"},
    {key: "nl", label: "lang.kwl.airvolume_calc.rated_ventilation", class: "text-center cellVolumeflow"},
    {key: "il", label: "lang.kwl.airvolume_calc.intensive_ventilation", class: "text-center cellVolumeflow"},
  ],
  unit_air_vol_fields_at: [
    {key: "airtype", label: "lang.kwl.airvolume_calc.ventilation_method", class: ""},
    {key: "totalSupplyAir", label: "lang.kwl.airvolume_calc.total_air_supply", class: ""},
    {key: "bdonp", label: "lang.kwl.building_data.number_of_people", class: ""},
    {key: "bdsvp", label: "lang.kwl.static_volumeflow.number_of_people", class: ""},
    {key: "bdvm", label: "lang.kwl.ventilation_measure", class: ""},
  ],
  unit_air_vol_18017_fields: [
    {key: "text", label: " ", tdClass: "col-10"},
    {key: "volume", label: " ", tdClass: "col-4 text-center"},
  ],
  storey_type: [
    {value: 0, text: "lang.kwl.building_data.multy_storey"},
    {value: 1, text: "lang.kwl.building_data.single_storey"},
  ],
  room_recording_fields: [
    {key: "description", label: "lang.kwl.airvolume_calc.room"},
    {key: "storey", label: "lang.kwl.airvolume_calc.storey", class: "cellStorey"},
    {key: "air_type", label: "lang.kwl.airvolume_calc.air_type", class: "cellAirType"},
    {key: "space", label: "lang.kwl.airvolume_calc.space", class: "text-right text-nowrap cellSpace"},
    {
      key: "ventilation_measure",
      label: "lang.kwl.airvolume_calc.ventilation_measure",
      class: "cellVentilationMeasure text-center text-nowrap"
    },
    {key: "options", label: " ", class: "text-nowrap text-right"},
  ],
  room_air_vol_fields: [
    {key: "description", label: "lang.kwl.airvolume_calc.room"},
    {key: "storey", label: "lang.kwl.airvolume_calc.storey", class: "cellSStorey text-nowrap"},
    {key: "air_type", label: "lang.kwl.airvolume_calc.air_type", class: "cellAirType text-nowrap"},
    {key: "window", label: "lang.kwl.airvolume_calc.window", class: "text-center text-nowrap"},
    {key: "space", label: "lang.kwl.airvolume_calc.space", class: "cellSpace text-right text-nowrap"},
    {key: "f_zu", label: "lang.kwl.airvolume_calc.f_zu", class: "text-right text-nowrap"},
    {key: "nl_zu", label: "lang.kwl.airvolume_calc.nl_zu", class: "cellSupply text-right text-nowrap"},
    {
      key: "nl_zu_extended",
      label: "lang.kwl.airvolume_calc.nl_zu_extended",
      class: "cellSupplyExtended text-right text-nowrap"
    },
    {key: "nl_ab", label: "lang.kwl.airvolume_calc.nl_ab", class: "cellSupply text-right text-nowrap"},
    {
      key: "nl_ab_extended",
      label: "lang.kwl.airvolume_calc.nl_ab_extended",
      class: "cellExhaustExtended text-right text-nowrap"
    },
    /*		{key: 'infiltration_air', label: 'lang.kwl.airvolume_calc.infiltration_air', sortable: true},
{key: 'ald', label: 'lang.kwl.airvolume_calc.ald', sortable: true},//14
*/ {key: "operationmode", label: "lang.kwl.airvolume_calc.operationmode", class: "cellOpterationMode text-center"},
    {
      key: "ventilation_measure",
      label: "lang.kwl.airvolume_calc.ventilation_measure",
      class: "cellVentilationMeasure text-nowrap"
    },
  ],
  room_volume_flow_fields: [
    {key: "description", label: "lang.kwl.overflow.room"},
    {key: "storey", label: "lang.kwl.airvolume_calc.storey"},
    {key: "air_type", label: "lang.kwl.overflow.air_type"},
    {key: "air_volume", label: "lang.kwl.overflow.uld", class: "text-right text-nowrap"},
    {key: "door_leaf", label: "lang.kwl.overflow.door_leaf", class: "text-right text-nowrap"},
    {key: "airvolume.uld", label: "lang.kwl.overflow.space", class: "text-right text-nowrap"},
    {key: "gap", label: "lang.kwl.overflow.gap", class: "text-right text-nowrap"},
  ],
  sections_fields: [
    {key: "description", label: "lang.kwl.valve_selection.section"},
    {key: "pipe_system_type", label: "lang.kwl.valve_selection.guid_system"},
    {key: "space", label: " "},
  ],
  system_options: [
    {value: 1, text: "lang.global.round"},
    {value: 2, text: "lang.global.oval"},
    //{value: 3, text: 'lang.global.mixed'},
  ],
  valves_fields: [
    {key: "type", label: "lang.kwl.valve_selection.room", class: "text-left text-nowrap"},
    {key: "storey", label: "lang.kwl.valve_selection.storey", class: "cellStorey text-left text-nowrap"},
    {key: "air_type", label: "lang.kwl.valve_selection.air_type", class: "cellAirType text-left text-nowrap"},
    {key: "nl_zu", label: "lang.kwl.valve_selection.nl_zu", class: "cellSupply text-right text-nowrap"},
    {key: "nl_ab", label: "lang.kwl.valve_selection.nl_ab", class: "cellExhaust text-right text-nowrap"},
    {
      key: "valvesAmmount",
      label: "lang.kwl.valve_selection.valves_ammount",
      class: "cellValvesAmmount text-right text-nowrap"
    },
    {key: "nr", label: "lang.kwl.valve_selection.nr", class: "text-center text-nowrap"},
    {
      key: "pipesExhaust",
      label: "lang.kwl.valve_selection.pipes_exhaust",
      class: "cellPipesExhaust text-right text-nowrap"
    },
    {
      key: "pipesSupply",
      label: "lang.kwl.valve_selection.pipes_supply",
      class: "cellPipesSupply text-right text-nowrap"
    },
    {
      key: "pipeAirvolume",
      label: "lang.kwl.valve_selection.pipe_airvolume",
      class: "cellPipesAirvolume text-right text-nowrap"
    },
    {key: "pipesystem", label: "lang.kwl.valve_selection.pipesystem", class: "cellPipesSystem text-right text-nowrap"},
  ],
  au_fo_options: [
    {value: 1, text: "lang.global.wall"},
    {value: 2, text: "lang.global.roof"},
  ],
  ewt_options: [
    {value: 1, text: "lang.kwl.sys_selection.lewt"},
    {value: 2, text: "lang.kwl.sys_selection.sewt"},
  ],
  devices_fields: [
    {key: "article.art_no", label: "lang.kwl.device_selection.art_no"},
    {key: "article.name", label: "lang.kwl.device_selection.name"},
    {key: "installation", label: "lang.kwl.device_selection.mounting"},
    //{key: 'airvolume', label: 'lang.kwl.device_selection.airvolume', title:'lang.kwl.device_selection.airvolume_info'},
    {
      key: "max_airvolume",
      label: "lang.kwl.device_selection.max_airvolume",
      title: "lang.kwl.device_selection.max_airvolume_info",
      class: "text-right text-nowrap"
    },
    {key: "article.wg", label: "lang.kwl.device_selection.wg", title: "lang.kwl.device_selection.sev_info"},
    {key: "selected", label: "lang.kwl.device_selection.selected", class: "text-center"},
    {key: "price", label: "lang.kwl.device_selection.price", class: "text-right text-nowrap"},
    {key: "details", label: "lang.kwl.device_selection.detail", class: "text-center"},
  ],
  equipments_fields: [
    {key: "art_no", label: "lang.kwl.device_selection.art_no", class: "cellArticleNumber"},
    {key: "article.name", label: "lang.kwl.device_selection.name", class: "cellArticleType"},
    {key: "details", label: "lang.kwl.device_selection.description", class: "cellDescription"},
    {key: "price", label: "lang.kwl.device_selection.price", class: "cellSinglePrice text-right text-nowrap"},
    {key: "quantity", label: "lang.kwl.device_selection.quantity", class: "cellQuantity text-right text-nowrap"},
    {
      key: "total_price",
      label: "lang.kwl.device_selection.total_price",
      class: "cellTotalPrice text-right text-nowrap"
    },
    {key: "detail", label: "lang.kwl.device_selection.detail"},
  ],
  combi_device_fields: [
    {key: "art_no", label: "lang.kwl.device_selection.art_no"},
    {key: "article.name", label: "lang.kwl.device_selection.name"},
    {key: "details", label: "lang.kwl.device_selection.description"},
    {key: "price", label: "lang.kwl.device_selection.price", class: "text-right text-nowrap"},
    {key: "quantity", label: "lang.kwl.device_selection.quantity", class: "text-right text-nowrap"},
    {key: "selection", label: "lang.global.selection"},
    {key: "total_price", label: "lang.kwl.device_selection.total_price", class: "text-right text-nowrap"},
    {key: "detail", label: "lang.kwl.device_selection.detail"},
  ],
  overview_material_fields: [
    {key: "article.art_no", label: "lang.kwl.device_selection.art_no"},
    {key: "article.name", label: "lang.kwl.device_selection.name"},
    {key: "details", label: "lang.kwl.device_selection.description"},
    {key: "price", label: "lang.kwl.device_selection.price", class: "text-right textnowrap"},
    {key: "quantity", label: "lang.kwl.device_selection.quantity", class: "text-right textnowrap"},
    {key: "total_price", label: "lang.kwl.device_selection.total_price", class: "text-right textnowrap"},
  ],
  user_articles_fields: [
    {key: "number", label: "lang.kwl.device_selection.art_no"},
    {key: "designation", label: "lang.kwl.device_selection.name"},
    {key: "description", label: "lang.kwl.device_selection.description"},
    {key: "price", label: "lang.kwl.device_selection.price", class: "text-right textnowrap"},
    {key: "quantity", label: "lang.kwl.device_selection.quantity", class: "text-right textnowrap"},
    {key: "total_price", label: "lang.kwl.device_selection.total_price", class: "text-right textnowrap"},
    {key: "detail", label: "lang.kwl.device_selection.detail"},
  ],
  user_own_articles_fields: [
    {key: "userArticle.number", label: "lang.kwl.user_article.art_no"},
    {key: "userArticle.designation", label: "lang.kwl.user_article.designation"},
    {key: "userArticle.description", label: "lang.kwl.user_article.description"},
    {key: "userArticle.article_group", label: "lang.kwl.user_article.article_group"},
    {key: "userArticle.price", label: "lang.kwl.user_article.price", class: "text-right textnowrap"},
    {key: "quantity", label: "lang.kwl.user_article.quantity", class: "text-right textnowrap"},
    {key: "total_price", label: "lang.kwl.user_article.total_price", class: "text-right textnowrap"},
    {key: "delete", label: " "},
  ],
  building_height: [
    {value: 0, text: "lang.kwl.building_data.height_low"},
    {value: 1, text: "lang.kwl.building_data.height_mid"},
    {value: 2, text: "lang.kwl.building_data.height_high"},
  ],
  window_options: [
    {value: true, text: "lang.global.with"},
    {value: false, text: "lang.global.without"},
  ],
  valves_options: [
    {value: 1, text: "lang.montage.ground"},
    {value: 2, text: "lang.montage.wall"},
    {value: 3, text: "lang.montage.ceiling"},
  ],
  room_article_fields: [
    {key: "type", label: "lang.global.room"},
    {key: "storey", label: "lang.building_data.storey", class: "cellStorey"},
    {key: "air_type", label: "lang.room.air_type", class: "cellAirType"},
    {key: "valvesAmmount", label: "lang.kwl.valves.valve_quantity", class: "cellValvesAmmount text-right text-nowrap"},
    //{key: 'number', label: 'Nr.'},
    {key: "pipesAmmount", label: "lang.kwl.valve_selection.pipes", class: "cellPipesAmmount text-right text-nowrap"},
    {key: "pipes_system", label: "lang.kwl.valve_selection.pipesystem", class: "cellPipesSystem"},
    {key: "pipes_diameter", label: "lang.kwl.valves.pipe_dimension", class: "cellPipesDiameter text-right text-nowrap"},
    {key: "valve_position", label: "lang.kwl.valves.in_outlet", class: "cellValvesPosition text-right text-nowrap"},
    {key: "detail", label: "lang.global.edit", class: ""},
  ],
  combination_article_fields: [
    {key: "type", label: "lang.global.room"},
    {key: "storey", label: "lang.building_data.storey"},
    {key: "air_type", label: "lang.room.air_type"},
    {key: "window", label: "lang.window"},
    {key: "ventilation_measure", label: "lang.kwl.airvolume_calc.ventilation_measure"},
    {key: "airvolume", label: "lang.kwl.combi_device.air_volume", class: "text-right text-nowrap"},
    {key: "device_type", label: "lang.global.device_type"},
    {
      key: "installation",
      label: "lang.kwl.systemselection.installation_position_type",
      class: "cellInstallation text-right text-nowrap"
    },
    {key: "mounting_position", label: "lang.kwl.systemselection.montage_position", class: "text-right text-nowrap"},
    {key: "quantity", label: "lang.kwl.combi_device.quantity", class: "text-right text-nowrap"},
    {key: "controlling_combo", label: "lang.kwl.combi_device.controlling_combo"},
    {key: "detail", label: "lang.global.edit"},
  ],
  single_room_article_fields: [
    {key: "type", label: "lang.global.room"},
    {key: "storey", label: "lang.building_data.storey"},
    {key: "air_type", label: "lang.room.air_type"},
    {key: "window", label: "lang.window"},
    {key: "ventilation_measure", label: "lang.kwl.airvolume_calc.ventilation_measure"},
    {key: "airvolume", label: "lang.kwl.combi_device.air_volume", class: "text-right text-nowrap"},
    {
      key: "installation",
      label: "lang.kwl.systemselection.installation_position_type",
      class: "cellInstallation text-right text-nowrap"
    },
    {key: "mounting_position", label: "lang.kwl.systemselection.montage_position", class: "text-right text-nowrap"},
    {key: "quantity", label: "lang.kwl.combi_device.quantity", class: "text-right text-nowrap"},
    {key: "detail", label: "lang.global.edit"},
  ],
  existence_options: [
    {value: 0, text: "lang.global.no"},
    {value: 1, text: "lang.global.yes"},
  ],
  ec_options: [
    {value: 0, text: "KWL EC45"},
    {value: 1, text: "KWL EC60"},
  ],
  ec_installation_options: [
    {value: 4, text: "lang.kwl.combi_device.facade_panel"},
    {value: 5, text: "lang.kwl.combi_device.reveal_element"},
    {value: 13, text: "lang.kwl.combi_device.pitched_roof"},
  ],
  els_installation_options: [
    {value: 6, text: "lang.montage.ELS_A"},
    {value: 7, text: "lang.montage.ELS_B"},
    {value: 8, text: "lang.montage.ELS_C"},
    {value: 9, text: "lang.montage.ELS_D"},
    {value: 10, text: "lang.montage.ELS_E"},
  ],
  mounting_position_options: [
    {value: 11, text: "lang.montage.finery"},
    {value: 12, text: "lang.montage.concealed"},
  ],
};

const getters = {
  getLangKeys: (state) => (payload) => {
    return state[payload.key];
  },
};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
